export enum AnalyticsEvent {
  ContinueEstimation = 'ContinueEstimation',
  CreateNewEstimation = 'CreateNewEstimation',
  CopyAiReview = 'CopyAiReview',
  ExportAiReview = 'ExportAiReview',
  CreateNewAiReviewRequest = 'CreateNewAiReviewRequest',
}
